export const GET_GENERAL_REQUEST = '@reports/GET_GENERAL_REQUEST';
export const GET_GENERAL_FAILURE = '@reports/GET_GENERAL_FAILURE';
export const GET_GENERAL_SUCCESS = '@reports/GET_GENERAL_SUCCESS';

export const GET_RESPONSIBLE_REQUEST = '@reports/GET_RESPONSIBLE_REQUEST';
export const GET_RESPONSIBLE_FAILURE = '@reports/GET_RESPONSIBLE_FAILURE';
export const GET_RESPONSIBLE_SUCCESS = '@reports/GET_RESPONSIBLE_SUCCESS';
